"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Clip32Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { d: "M21.6569 8.92894L13.1697 17.4161C12.7781 17.8077 12.7777 18.4346 13.1716 18.8284C13.5606 19.2175 14.1984 19.2158 14.5918 18.8224L23.0731 10.3411C23.8517 9.56251 24.7747 7.8041 23.0776 6.10705C21.3806 4.41001 19.6089 5.32002 18.8274 6.10149L7.50916 17.4198C5.95187 18.9771 5.34709 22.3177 7.51472 24.4853C9.68234 26.6529 13.0216 26.0495 14.5801 24.4909L25.8995 13.1716L27.3137 14.5858L15.9944 25.9051C13.6543 28.2452 9.50018 29.2992 6.1005 25.8995C2.70083 22.4998 3.75587 18.3446 6.09495 16.0056L17.4132 4.68728C19.1707 2.92985 22.2927 2.49375 24.4918 4.69284C26.6909 6.89193 26.0484 10.1942 24.4873 11.7554L16.006 20.2366C14.8332 21.4094 12.9291 21.4144 11.7574 20.2426C10.582 19.0673 10.5833 17.1741 11.7555 16.0018L20.2426 7.51472L21.6569 8.92894Z", fill: "#383F49" }));
}
function Clip32(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Clip32Svg, Object.assign({}, svgProps)));
}
exports.default = Clip32;
//# sourceMappingURL=Clip32.js.map